import { render, staticRenderFns } from "./LLInputSuggestions.vue?vue&type=template&id=65760945&scoped=true"
import script from "./LLInputSuggestions.vue?vue&type=script&lang=js"
export * from "./LLInputSuggestions.vue?vue&type=script&lang=js"
import style0 from "./LLInputSuggestions.vue?vue&type=style&index=0&id=65760945&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65760945",
  null
  
)

export default component.exports